'use strict';

import appStore from "./AppStore";

/*
 * Calls a set of async functions in series or parallel depending on whether devmode is set.
 *
 * If devmode is set, the functions will be called in series to support the lambda-api --warm-containers flag.
 * If devmode is NOT set, the functions will be called in parallel for performance
 *
 * @param funcs - A list of async functions to call.
 * @param devmode - True/false
 */
async function multiCallUtil(funcs) {
    if (appStore.isDevMode()) {
        let results = []
        for (let f of funcs) {
            results.push(await f());
        }
        return results;
    } else {
        return Promise.all(funcs.map(f => f()));
    }
}

export default multiCallUtil;